import React from "react";

import WidgetDelete from "./widget-delete";

interface Props {
  onClose?: any;
  entity: any;
  onSuccess?: any;
  onError?: any;
  arrayHelpers?: any;
  fields: any[];
}

function WidgetDeleteContainer(props: Props) {
  // const { id } = useParams<any>();

  const { onClose } = props;

  const { entity } = props;

  const {
    /*entity,*/ onSuccess /*, onError*/,
    arrayHelpers,
    fields = [],
  } = props;

  /*async*/ function confirmDelete(event?: any) {
    // const index = parentEntity.widgets.indexOf(entity);
    // parentEntity.widgets[index] = values;
    const index = fields.indexOf(entity);
    if (arrayHelpers) {
      arrayHelpers.remove(index);
    } else {
      console.error("arrayHelpers does not exist!");
      fields.splice(index, 1);
    }
    if (onSuccess) {
      onSuccess(event);
    }
    // return values;
  }

  return (
    <WidgetDelete
      confirmDelete={confirmDelete}
      onClose={onClose}
    ></WidgetDelete>
  );
}

export default WidgetDeleteContainer;
